import request from "@/utils/request";

// 获取出库单列表
export function getList(data) {
  return request.post("/wms/out/stock/queryPage", data);
}

export function edit(data) {
  return request.post(
    `/wms/out/stock/${data.id ? "updateById" : "insert"}`,
    data
  );
}

export function audit(data) {
  return request.post("/wms/out/stock/audit", data);
}

export function del(id) {
  return request.get("/wms/out/stock/deleteById/" + id);
}

export function findById(id) {
  return request.get("/wms/out/stock/findById/" + id);
}
